
  import notifications from '~/mixins/pages/mission-control/notifications'
  export default {
    name: 'Theme2MobileNotificationNavbar',
    mixins: [notifications],
    data() {
      return {
        displayNotificationDialog: false
      }
    },
    methods: {
      onClickNotification() {
        this.displayNotificationDialog = true
      },
      onClickHandler(item) {
        this.displayNotificationDialog = false
        this.onClickNotificationHandler(item)
      }
    }
  }
